module.exports = __webpack_public_path__ + "img/bug01.13207c97.jpg";